export enum InputState {
    NotSpecified = "not-specified",
    Specified = "specified",
}

export type InputValueState<T> = {
    state: InputState;
    data?: T;
};
